// @react
import React from 'react'
// @types
import type { ReactElement } from 'react'
import type {
  GetUserQuery,
  GetUserQueryVariables,
} from 'lib/graphql/graphqlTypes'
// @graphql
import { useQuery } from '@apollo/client'
import { GET_USER } from 'graphql/queries/user.query'
import { LinkType } from 'lib/graphql/graphqlTypes'
// @libraries
import { makeStyles } from '@material-ui/core/styles'
// @components
import Grid from '@bit/atd.web.grid'
import Box from '@bit/atd.web.box'
import TextLink from '@bit/atd.web.text-link'
import Spacer from '@bit/atd.web.spacer'
// @module common components
import QueryError from 'modules/common/components/Errors/QueryError'

/**
 * 3.0.1.5 MyATD - Benefits Center - Member Resources
 * https://www.figma.com/file/jCo0D2EYkVbuBX1TjR1enA/ATD-MyATD-Desktop-2020?node-id=3528%3A41884
 */

const useStyles = makeStyles({
  body: {
    paddingTop: '6px !important',
  },
  item: {
    width: '100%',
  },
})

const AdditionalMemberResources = (): ReactElement => {
  /******************************************
   * HOOKS
   ******************************************/

  const { loading: isLoading, error: isError, data } = useQuery<
    GetUserQuery,
    GetUserQueryVariables
  >(GET_USER, { fetchPolicy: 'cache-only' })

  const classes = useStyles()

  /******************************************
   * RENDERS
   ******************************************/

  if (isLoading) {
    return <span>Loading...</span>
  }
  if (isError || !data) {
    return <QueryError />
  }
  return (
    <Box
      classNames={{
        body: classes.body,
      }}
      variant={'subModule'}
      header={{
        title: 'Additional Resources',
      }}
    >
      <Grid container>
        {data.user?.membership?.additionalMemberResources?.map(
          (item, index) => {
            return (
              <Grid item key={item.url} className={classes.item}>
                {/* Link */}
                <TextLink
                  variant="standalone"
                  target={
                    item?.linkType === LinkType.EXTERNAL ? '_blank' : '_self'
                  }
                  href={item.url}
                >
                  {item.title}
                </TextLink>

                {/* Spacer */}
                {data?.user?.membership?.additionalMemberResources &&
                  data?.user?.membership?.additionalMemberResources?.length >
                    1 &&
                  data?.user?.membership?.additionalMemberResources?.length !==
                    index + 1 && <Spacer fullWidth size={16} />}
              </Grid>
            )
          },
        )}
      </Grid>
    </Box>
  )
}

export default AdditionalMemberResources
